export default function truncate(string: string | null | undefined, truncateLen: number): string {
  if (!string) return '';
  return string.length > truncateLen ? `${string.slice(0, truncateLen)} ...` : string;
}
